import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IVelvetCardLinkProps } from "./VelvetCardLink.props";

export const VelvetCardLink = ({ children, className, link }: IVelvetCardLinkProps) => {
  const classes = cn(
    "group block border-t border-parchment/20 bg-transparent transition-[background-color,border-color,color] duration-200 ease-out",
    link &&
      "hover:border-thread hover:text-thread focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
    className,
  );

  if (!link) return <article className={classes}>{children}</article>;

  const Link = getComponent("Link");
  return (
    <Link
      aria-label={link.accessibilityLabel || undefined}
      className={classes}
      href={link.href}
      rel={link.openInNewTab ? "noopener noreferrer" : undefined}
      target={link.openInNewTab ? "_blank" : undefined}
    >
      {children}
    </Link>
  );
};

VelvetCardLink.displayName = "Content::VelvetCardLink";
